module.exports = __webpack_public_path__ + "static/media/DaMuksLogo.59655b49.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/DaMuksLogo.png
// module id = 113
// module chunks = 0